/* 仓库模块API */

import { GET, POST, download,DELETE,PUT, uploading, POSTFormData,EXPORT } from '@/request/http'

//基础-仓库管理
//分页查询
export const getStoreMarkPage = p => POST('/warehouse/page', p,5);
//查询全部
export const getAllStoreList = p => POST('/warehouse/list', p, 5);
//新增
export const addOneStore = p => POST('/warehouse/save', p,5);
//修改
export const updateOneStore = p => POST('/warehouse/update', p,5);
//删除
export const removeOneStore = p => POST('/warehouse/remove', p,5);

//基础-分组管理
//查询全部
export const getAllGoodsGroupList = p => POST('/warehouse/itemclassify/list', p,5);
//新增
export const addOneGoodsGroup = p => POST('/warehouse/itemclassify/save', p,5);
//修改
export const updateOneGoodsGroup = p => POST('/warehouse/itemclassify/update', p,5);
//删除
export const removeOneGoodsGroup = p => POST('/warehouse/itemclassify/remove', p,5);


//基础-物品管理
//分页查询
export const getGoodsPartPage = p => POST('/warehouse/item/page', p,5);
//查询全部
export const getAllGoodsList = p => POST('/warehouse/item/list', p,5);
//新增
export const addOneGoods = p => POST('/warehouse/item/save', p,5);
//修改
export const updateOneGoods = p => POST('/warehouse/item/update', p,5);
//删除
export const removeOneGoods = p => POST('/warehouse/item/remove', p,5);
//通过id查询物品
export const getGoodsInfoById = p => POST('/warehouse/item/get', p,5);

//基础-供应商管理
//新增供应商
export const addOneSupplier = p => POST('/warehouse/supplier/save', p,5);
//删除供应商
export const removeOneSupplier = p => POST('/warehouse/supplier/remove', p,5);
//修改供应商
export const updateOneSupplier = p => POST('/warehouse/supplier/update', p,5);
//分页查询供应商
export const getSupplierListPartPage = p => POST('/warehouse/supplier/page', p,5);


//基础-项目管理
//新增项目
export const addOneProject = p => POST('/warehouse/project/save/project-info', p,5);
//删除项目
export const removeOneProject = p => DELETE('/warehouse/project/{id}/project-info', p,5);
//修改项目
export const updateOneProject = p => PUT('/warehouse/project/replace/project-info', p,5);
//分页查询项目
export const getProjectListPartPage = p => GET('/warehouse/project/like/project-info', p,5);


/******************************** 出入库操作 ***********************************/
//新增物品入库
export const sumbitGoodsInStore = p => uploading('/warehouse/stockoutinrecord/save', p, 5);
//上传物品照片   
export const uploadGoodsPictures = p => POSTFormData('/warehouse/stockoutinrecord/update-item-image', p, 5);
//导入上传物品入库清单
export const importInStorageGoodsInventory = p => POSTFormData('/warehouse/stockoutinrecord/save-excel/import', p, 5);
//分页查询归还入库记录
export const getReturnStoreListPartPage = p => POST('/warehouse/stockoutinrecord/page/returninstorage', p, 5);
//确认归还入库 
export const affirmReturnStorage = p => POST('/warehouse/stockoutinrecord/returntostorage', p, 5);
//根据归还编号查询物品信息 
export const getGoodsInfoByNumber = p => POST('/warehouse/stockoutinrecord/lenditeminfo', p, 5);

//新增物品出库
export const sumbitGoodsOutStore = p => POST('/warehouse/stockoutinrecord/outwarehouse', p, 5);
//调拨出入库
export const sumbitGoodsAllocationStore = p => POST('/warehouse/stockoutinrecord/allocationandstorage', p, 5);
//借出出库
export const sumbitGoodsLendOutStore = p => POST('/warehouse/stockoutinrecord/lendout', p, 5);
//根据物品id和仓库id查询物品库存数量
export const getGoodsNumberById = p => POST('/warehouse/stock/numberofwareitems', p, 5);


/******************************** 出入库记录查询 ***********************************/
//查询出入库记录  
export const getOutInStoreRecord = p => GET('/warehouse/recording/outinwarehouse/all/outin-recording', p, 5);
//根据出入库编号查询订单详情  
export const getOutInStoreDetailByNum = p => GET('/warehouse/recording/outinwarehouse/items/{outInNo}/outin-recording', p, 5);
//查询出库记录  
export const getOutStoreRecord = p => GET('/warehouse/recording/outinwarehouse/out/outin-recording', p, 5);
//查询库存信息
export const getInventoryInfo = p => POST('/warehouse/stock/page', p,5);
//查询库存流水信息
export const getInventoryWaterInfo = p => GET('/warehouse/flow/all/outin-flow', p, 5);


/******************************** 申请记录 ***********************************/
//分页查询申请记录
export const getApplyListPartPage = p => GET('/warehouse/recording/apply/condition/outin-recording', p,5);
//根据申请出入库编号查询物品详情
export const getGoodsListByOutInNo = p => GET('/warehouse/recording/apply/{outInNo}/outin-recording', p, 5);
//根据申请出入库编号查询订单详情
export const getOrderDetailByOutInNo = p => GET('/warehouse/recording/apply/details/{outInNo}/outin-recording', p,5);
//撤销申请
export const backoutApplyOrder = p => PUT('/warehouse/recording/apply/{outInNo}/outin-recording', p, 5);
//确认申请出库/入库
// export const affirmApplyOutInStorage = p => POST('/warehouse/application/outInwarehouse/application-record', p,5);

/******************************** 审批记录 ***********************************/
//分页查询待审批记录
export const getWaitApprovalListPartPage = p => GET('/warehouse/approval/all/wait-approval', p, 5);
//分页查询历史审批记录
export const getHistoryApprovalListPartPage = p => GET('/warehouse/approval/history/wait-approval', p, 5);
//查看待审批物品详情
export const getApprovalGoodsListByNum = p => GET('/warehouse/approval/items/{outInNo}/wait-approval', p,5);
//审批出库/入库
export const approvalApplyOrder = p => POST('/warehouse/approval/submit/wait-approval', p,5);

/******************************** 库管确认记录 ***********************************/
//分页查询待确认记录
export const getWaitAffirmListPartPage = p => GET('/warehouse/confirm/all/outin-confirm', p, 5);
//分页查询历史确认记录
export const getHistoryAffirmListPartPage = p => GET('/warehouse/confirm/history/outin-confirm', p, 5);
//查看待确认物品详情
export const getAffirmGoodsListByNum = p => GET('/warehouse/confirm/items/{outInNo}/{warehouseId}/outin-confirm', p,5);
//确认出库/入库
export const approvalAffirmOrder = p => POST('/warehouse/confirm/submit/outin-confirm', p,5);

//获取当前登录人所有仓库
export const getMyAllStorageIdList = p => GET('/warehouse/warehouseManager', p, 5);
//分页查询调拨入库记录
// export const getallotinstoragepage = p => POST('/warehouse/stockoutinrecord/page/getallotinstorage', p, 5);
//导出库存 
export const exportWarehouseStorage = p => EXPORT('/warehouse/stock/in-stock-excel/export', p, 4)  
//导出库存流水 
export const exportWarehouseStorageWater = p => EXPORT('/warehouse/flow/flow-excel/export', p, 4)
//下载模板
export const downloadInWarehouseModel = p => download('/warehouse/stockoutinrecord/excel-template/export', p, 4)



// WEBPACK FOOTER //
// ./src/api/modules/storage.js